<template>
    <div>
        <page-title>账户列表</page-title>

        <datagrid v-if="dataShow" :columns="cols" subListName :dataList="dataList" :pagination="false">
            <template #default="{columns, data}">
                <!-- <Table :columns="columns" :data="data" border stripe size="small" style="margin:10px">
                </Table>-->
            </template>
        </datagrid>
    </div>
</template>

<script>
import pageTitle from '_c/title/page-title'
import datagrid from '_c/datagrid';
export default {
    components: { pageTitle, datagrid },
    data() {
        return {
            dataShow: true,
            dataList: [],
            cols: [
                { title: '参与人', key: 'memberId', dict: ['bizObjects', 'member',true] },
                { title: '收款人', key: 'payeeId', dict: ['bizObjects', 'member',true] },
                { title: '账户类型', key: 'type',dict:['account','accountType'] },
                { title: '总金额', key: 'amountTotal' },
                { title: '余额', key: 'amountAvaliable' },
            ]
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            let data = {
                url: "CORE-MEMBER/messageService/accountService/queryAccountsByCurrentUser",
                body: {}
            }
            this.dataShow = false
            this.invoke(data).then(res => {
                this.dataList = res
                this.dataShow = true

            }).catch(err => {
                this.dataShow = true
            })
        }
    }

}
</script>

<style lang="scss" scoped>
</style>